import React, { Component, Fragment } from 'react';
import { Row, Col, Card, Button } from 'antd';
import { withAsyncActions } from 'react-async-client';
import { Field } from 'formik';

import { postMessage, getMessages } from 'actions/asyncActions';
import withForm from 'components/hocs/withForm';
import Text from 'components/common/form/Text';
import yup from 'yup';
import File from "../../../common/form/File";


const SUPPORTED_FORMATS = ["doc", "xls", "ppt","png", "jpg", "tif", "pdf", "xlsx"]

@withAsyncActions({
    formAction: postMessage,
    getMessages: getMessages
        .withPayload(({ appId }) => appId)
        .withOptions({ dispatchOnMount: true }),
})
@withForm({
    validationSchema: yup.object({
        message: yup.string().required(),
        file: yup.mixed().test(
            'format',
            'Неподдерживаемый формат',
            (value) => value && SUPPORTED_FORMATS.includes(value.name.split('.').pop())
        ),
    }),
    handleSubmit: (values, { resetForm, props: { formAction, appId } }) => {
        formAction.dispatch({ values, appId });
        resetForm();
    }
})
export default class ApplicationChat extends Component {
    componentDidMount() {
        this.interval = setInterval(() => {
            this.props.getMessages.refresh();
        }, 5000);
    }

    componentDidUpdate(prev) {
        const {formAction: { meta: pmeta}} = prev;
        const {formAction: { meta }} = this.props;
        if (meta.success !== pmeta.success && meta.success) {
            this.props.getMessages.refresh();
        }
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    renderMessages(messages) {
        const downloadLink = (file) => <a href={file.url} target="_blank" className="ant-card-link">(скачать файл)</a>;

        return messages.map((message) => (
            <p key={message.id}>
                <span>{message.name}: </span>
                {message.message} {message.files.length ? downloadLink(message.files[0]) : ''}
            </p>
        ));
    }

    render() {
        const {data: messages} = this.props.getMessages;
        return (
            <Fragment>
                <div className="application-cards">
                    <Card title="Чат по заявке" bordered={false} style={{width: '100%'}}>
                        <div>
                            {this.renderMessages(messages && messages.length ? messages : [])}
                        </div>
                        <Row gutter={20}>
                            <Col xs={24}>
                                <Field
                                    name='message'
                                    component={Text}
                                    placeholder='Текст сообщения'
                                />
                            </Col>
                            <Col xs={24}>
                                <Field
                                    name='file'
                                    component={File}
                                />
                            </Col>
                            <Col xs={24}>
                                <Button type="primary" htmlType="submit" className="sm-l-m-20">
                                    Отправить
                                </Button>
                            </Col>
                        </Row>
                    </Card>
                </div>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ApplicationChat.js